enum AttachmentPreviewMethod {
    /** Side-by-side preview not supported. */
    Unsupported = 0,

    /** Use the image lightbox UI to render the attachment. */
    Image = 1,

    /** Use OWA to render an embedded mail item. */
    MailItem = 2,

    /** Use OWA's calendar UI to reder the file (e.g. ICS). */
    CalendarEvent = 3,

    /** Use the WAC to render the file (e.g. Office docs). */
    Wac = 4,

    /** Use Suite Extensions to render the file (e.g. GPX). */
    SuiteExtensions = 5,

    /** Use the audio player to render the file (e.g. MP3). */
    Audio = 6,

    /** Render the file as plain text. */
    Text = 7,

    /** Use the native view for pdf files. */
    NativeView = 8,

    /** View Google docs in iframe */
    GoogleDoc = 9,

    /** Use ItemReadingPane to render item attachment */
    ItemAttachment = 10,

    /** Use the video player to render the file (e.g. MP4). */
    Video = 11,

    /** Use the MSPDF.kit for pdf files. */
    MsPdf = 12,
}

export default AttachmentPreviewMethod;
